import { Elements } from '@stripe/react-stripe-js';

import { stripe } from '../../../stripe';
import { ReactNode } from 'react';

// const FAMILY = 'Cera Round';

interface StripeProviderProps {
	children: ReactNode;
}

// type RawFont = [fileName: string, weight: number];
// type Font = {
// 	family: string;
// 	// src: string;
// 	weight: string;
// };

// const rawFonts: RawFont[] = [
// 	['CeraRoundProBlack', 900],
// 	['CeraRoundProBold', 700],
// 	['CeraRoundProMedium', 500],
// 	['CeraRoundProRegular', 400],
// 	['CeraRoundProLight', 300],
// 	['CeraRoundProThin', 100]
// ];

// const fonts: Font[] = rawFonts.map(([fileName, weight]) => ({
// 	family: FAMILY,
// 	weight: String(weight)
// }));

export const StripeProvider = ({
	children
}: StripeProviderProps): JSX.Element => (
	<Elements stripe={stripe}>{children}</Elements>
);
